import React from 'react';
import { Navbar } from '../../components';
import { PepCartHeader } from '../../containers';

const PepCart = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <PepCartHeader />
        </div>
    </div>
  )
}

export default PepCart